import { AdmissionType as StateAdmissionTypeKey, EvaluationStatus } from '@/pipeline/stateMachine';

export interface Document {
  name?: string;
  dataUrl?: string;
}

export interface EvaluationSecondGraduation {
  id?: number;
  institution?: string;
  courseName?: string;
  year?: string;
  document?: Document;
  documentBack?: Document;
  hasAcceptedToS?: boolean;
}

export interface EvaluationTransferGraduation {
  id?: number;
  institution?: string;
  courseName?: string;
  periodYear?: string;
  document?: Document;
  hasAcceptedToS?: boolean;
}

export interface EvaluationEnemGrades {
  languages?: number;
  humanScience?: number;
  natureScience?: number;
  math?: number;
  essay?: number;
}

export interface EvaluationEnem {
  id?: number;
  year?: string;
  subscriptionNumber?: string;
  grades?: EvaluationEnemGrades;
  hasAcceptedToS?: boolean;
}

export interface AdmissionType {
  id?: number;
  name?: string;
  description?: string;
  stateKey?: StateAdmissionTypeKey;
}

export interface Institution {
  id: number;
  name: string;
}

export interface AdmissionState {
  admissionId?: number;
  admissionType?: AdmissionType;
  availableAdmissionTypes?: AdmissionType[];
  availableEnemYears?: string[];
  availableInstitutions?: Institution[];
  enem?: EvaluationEnem;
  evaluationStatus?: EvaluationStatus;
  secondGraduation?: EvaluationSecondGraduation;
  transferGraduation?: EvaluationTransferGraduation;
}

const admission: AdmissionState = {
  admissionId: undefined,
  admissionType: undefined,
  availableAdmissionTypes: [],
  availableEnemYears: [],
  availableInstitutions: [],
  enem: undefined,
  evaluationStatus: undefined,
  secondGraduation: undefined,
  transferGraduation: undefined,
};

export default admission;
